import axios from "axios";

//const BASE_URL = 'http://localhost:8000'; // USE this for local development. comment next line
// const BASE_URL = "http://172.105.253.129:8000";
 const BASE_URL = "https://backend.uplsnipe.com"; // must ENABLE before push

const securedInstance = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

// Add token interceptor
securedInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default securedInstance;
